import { render } from "./ClassesView.vue?vue&type=template&id=2dc85860&scoped=true"
import script from "./ClassesView.vue?vue&type=script&lang=js"
export * from "./ClassesView.vue?vue&type=script&lang=js"

import "./ClassesView.vue?vue&type=style&index=0&id=2dc85860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc85860"]])

export default __exports__